/**
 * Master registry of all available Quick Access items.
 *
 * Each item: { key, name, route, icon, category, gradient, screen_codeflag, module_codeflag }
 *
 * `key` is the stable identifier stored in the DB (module_key).
 * `gradient` is optional CSS for pill display in the top bar.
 */

var STARR_Menu = require("./STARR_Menu");

// ── The 6 original hardcoded quick-access buttons ──────────────────────
var BUILT_IN_ITEMS = [
  {
    key: "command_centre",
    name: "CAC",
    route: "/command-centre",
    icon: "mdi-bullseye-arrow",
    icon_color: "#E11D65",
    category: "Quick Access",
    gradient: "linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)",
    screen_codeflag: [],
    module_codeflag: [],
  },
  {
    key: "my_work_inbox",
    name: "My Work",
    route: "/my_work_inbox",
    icon: "mdi-briefcase-outline",
    icon_color: "#059669",
    category: "Quick Access",
    gradient: "linear-gradient(90deg, #10B981 0%, #059669 50%, #047857 100%)",
    screen_codeflag: [],
    module_codeflag: [],
  },
  {
    key: "setup_guide",
    name: "Setup Guide",
    route: "/setup_guide",
    icon: "mdi-cog-outline",
    icon_color: "#7C3AED",
    category: "Quick Access",
    gradient: "linear-gradient(90deg, #6366F1 0%, #4F46E5 50%, #4338CA 100%)",
    screen_codeflag: [],
    module_codeflag: [],
  },
  {
    key: "drona_agent",
    name: "Drona AI",
    route: "/drona_agent",
    icon: "mdi-robot-outline",
    icon_color: "#0891B2",
    category: "Quick Access",
    gradient: "linear-gradient(90deg, #1E1E2F 0%, #2D2B55 50%, #3730A3 100%)",
    screen_codeflag: [],
    module_codeflag: [],
  },
  {
    key: "solutions",
    name: "Solutions",
    route: "/solutions",
    icon: "mdi-compass-outline",
    icon_color: "#2563EB",
    category: "Quick Access",
    gradient: "linear-gradient(90deg, #0EA5E9 0%, #2563EB 50%, #7C3AED 100%)",
    screen_codeflag: [],
    module_codeflag: [],
  },
];

// ── Flatten sidebar menu items into a list of { key, name, route, ... } ──

function flattenMenuItems(menuList, parentCategory) {
  var items = [];
  for (var i = 0; i < menuList.length; i++) {
    var item = menuList[i];
    var category = parentCategory || item.name || "";

    // Leaf item with a route
    if (item.to && item.name) {
      var key = item.to.replace(/^\//, "").replace(/\//g, "_").replace(/-/g, "_");
      items.push({
        key: key,
        name: item.name,
        route: item.to,
        icon: item.svg_icon ? "" : "mdi-circle-outline",
        category: category,
        gradient: "",
        screen_codeflag: item.screen_codeflag || [],
        module_codeflag: item.module_codeflag || [],
      });
    }

    // Recurse into children
    if (item.children && item.children.length > 0) {
      var childItems = flattenMenuItems(item.children, category);
      for (var j = 0; j < childItems.length; j++) {
        items.push(childItems[j]);
      }
    }
  }
  return items;
}

var MENU_ITEMS = flattenMenuItems(STARR_Menu.FullSideMENU, "");

// Deduplicate: built-in items take priority
var builtInKeys = {};
for (var b = 0; b < BUILT_IN_ITEMS.length; b++) {
  builtInKeys[BUILT_IN_ITEMS[b].key] = true;
}

var ALL_QUICK_ACCESS_ITEMS = BUILT_IN_ITEMS.slice();
for (var m = 0; m < MENU_ITEMS.length; m++) {
  if (!builtInKeys[MENU_ITEMS[m].key]) {
    ALL_QUICK_ACCESS_ITEMS.push(MENU_ITEMS[m]);
    builtInKeys[MENU_ITEMS[m].key] = true; // prevent duplicates from children
  }
}

// Default favourite keys for first-time users
var DEFAULT_FAVOURITE_KEYS = BUILT_IN_ITEMS.map(function (item) {
  return item.key;
});

// Category → gradient mapping
var CATEGORY_GRADIENTS = {
  "Quick Access": "linear-gradient(90deg, #6366F1 0%, #4F46E5 50%, #4338CA 100%)",
  "Strategy": "linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)",
  "Team": "linear-gradient(90deg, #10B981 0%, #059669 50%, #047857 100%)",
  "Act": "linear-gradient(90deg, #0EA5E9 0%, #2563EB 50%, #7C3AED 100%)",
  "Review": "linear-gradient(90deg, #1E1E2F 0%, #2D2B55 50%, #3730A3 100%)",
  "Reward": "linear-gradient(90deg, #F59E0B 0%, #D97706 50%, #B45309 100%)",
  "Masters": "linear-gradient(90deg, #64748B 0%, #475569 50%, #334155 100%)",
  "Settings": "linear-gradient(90deg, #64748B 0%, #475569 50%, #334155 100%)",
  "FMS": "linear-gradient(90deg, #14B8A6 0%, #0D9488 50%, #0F766E 100%)",
};

// Category → color mapping for icons
var CATEGORY_COLORS = {
  "Quick Access": "#6366F1",
  "Strategy": "#9333EA",
  "Team": "#2563EB",
  "Act": "#EA580C",
  "Review": "#16A34A",
  "Reward": "#D97706",
  "Masters": "#64748B",
  "Settings": "#71717A",
  "FMS": "#0D9488",
};

// Per-item icon color lookup (key → color). Built-in items use their
// own unique color; other items fall back to their category color.
var ITEM_ICON_COLORS = {};
for (var ic = 0; ic < ALL_QUICK_ACCESS_ITEMS.length; ic++) {
  var _item = ALL_QUICK_ACCESS_ITEMS[ic];
  ITEM_ICON_COLORS[_item.key] = _item.icon_color
    || CATEGORY_COLORS[_item.category]
    || "#94A3B8";
}

module.exports = {
  ALL_QUICK_ACCESS_ITEMS: ALL_QUICK_ACCESS_ITEMS,
  BUILT_IN_ITEMS: BUILT_IN_ITEMS,
  DEFAULT_FAVOURITE_KEYS: DEFAULT_FAVOURITE_KEYS,
  CATEGORY_GRADIENTS: CATEGORY_GRADIENTS,
  CATEGORY_COLORS: CATEGORY_COLORS,
  ITEM_ICON_COLORS: ITEM_ICON_COLORS,
};
